module.exports = __webpack_public_path__ + "img/case-tax.8c21ae40.jpg";